<main>
    <section class="heroHeader pb-md-5">
        <div class="customContainer container-fluid heroContainer">
            <img src="../assets/img/hero/legal.jpg" alt="ALPHERA Legal Notice" class="img-fluid">
            <div class="container">
                <div class="containerWrapper position-relative">
                    <div class="heroCopy">
                        <h1>Legal Notice</h1>
                        <p>We appreciate your interest. Please take a moment to review the Legal Notice for the ALPHERA Financial Services Website. </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="introSec bgPattern">
        <div class="container">
            <div class="containerWrapper">
                <div class="breadCrumb">
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/legal-notice">Legal Notice</a></li>
                    </ul>
                </div>
                
            </div>
        </div>
    </section>


    <section class="pTB accordionSec">
        <div class="container">
            <div class="containerWrapper">
               <h3>Legal Notice</h3>
               <div class="accordion accordionWrapper" id="accordionLegalNotice">

                    <div class="accordion-item accordionItem">
                        <a href="javascript:void(0);" class="accordion-header accordionHeader collapsed" data-bs-toggle="collapse" data-bs-target="#accordion_LegalNoticeSeven" aria-expanded="false" aria-controls="accordion_LegalNoticeSeven">
                            Respect for Human Rights and Environment Related Standards.
                        </a>
                        <div id="accordion_LegalNoticeSeven" class="accordion-collapse collapse" data-bs-parent="#accordionLegalNotice">
                            <div class="accordion-body accordionBody">
                                <p>The BMW Group recognizes its responsibility as a company to respect human rights and environment-related standards. This applies not only to our own business activities, but also to our global supply chains.</p>
                                <br>
                                <p>
                                    Learn more about our approach and due diligence process in the following <a href="https://www.bmwgroup.com/content/dam/grpw/websites/bmwgroup_com/company/downloads/en/2025/BMW_Group_Compliance_Menschenrechte_Grundsatz_EN.pdf">policy statement</a> or by clicking on <a href="https://www.bmwgroup.com/humanrights">www.bmwgroup.com/humanrights</a>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item accordionItem">
                        <a href="javascript:void(0);" class="accordion-header accordionHeader collapsed" data-bs-toggle="collapse" data-bs-target="#accordion_LegalSpeakUp" aria-expanded="false" aria-controls="accordion_LegalSpeakUp">
                            BMW Group SpeakUP Line.
                        </a>
                        <div id="accordion_LegalSpeakUp" class="accordion-collapse collapse" data-bs-parent="#accordionLegalNotice">
                            <div class="accordion-body accordionBody">
                                <p>
                                    Responsible, sustainable and lawful behaviour is an integral part of the BMW Group's values. The BMW Group's whistleblower system is open to all employees, business partners, customers and other third parties who wish to report specific or potential violations of the law. This enables risks to be recognised and addressed at an early stage and, if necessary, appropriate remedial action to be taken.
                                    <br><br>
                                    Confidentiality and the protection of whistleblowers are our top priority. If desired, information can also be provided anonymously.
                                    <br><br>
                                    The BMW Group SpeakUP Line is available in a total of 70 languages across all countries where the BMW Group operates and it is available throughout the day (local rates apply).<br><br>

<strong>BMW Group SpeakUP Line Contact Information:</strong><br>
<strong>Tel:</strong> 021 427 7937 <br>
<strong>Access Code:</strong> 115355<br><br>

Further information on the whistleblowing channels and the procedure for handling reports can be found here:<br>
<a href="https://www.bmwgroup.com/en/company/compliance.html">BMW Group Compliance</a><br><br>



                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item accordionItem">
                        <a href="javascript:void(0);" class="accordion-header accordionHeader collapsed" data-bs-toggle="collapse" data-bs-target="#accordion_LegalNoticeTwo" aria-expanded="false" aria-controls="accordion_LegalNoticeTwo">
                            E-mail legal disclaimer.
                        </a>
                        <div id="accordion_LegalNoticeTwo" class="accordion-collapse collapse" data-bs-parent="#accordionLegalNotice">
                            <div class="accordion-body accordionBody">
                                <ol>
                                    <li>Email messages and any attachments are confidential and intended solely for the addressee. If you have received this message in error, please notify the sender from BMW Financial Services from which this message originates immediately. Any unauthorised use, alteration or dissemination is prohibited.</li>
                                    <li>BMW Financial Services (South Africa) (Pty) Ltd (Registration Number 1990/004670/07), accepts no liability whatsoever for any loss whether it be direct, indirect or consequential, arising from information made available and actions resulting there from.</li>
                                    <li>Please note that BMW Financial Services (South Africa) (Pty) Ltd only bind themselves by way of signed agreements. 'Signed' refers to a hand-written signature, excluding any signature appended by 'electronic communication' as defined in the Electronic Communications and Transactions Act, no. 25 of 2002.</li>
                                </ol>
                                <div class="col-md-5 col-lg-3 btnWrapper">
                                <a routerLink="/terms-conditions" class="button button-g-blue">Terms and Conditions</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item accordionItem">
                        <a href="javascript:void(0);" class="accordion-header accordionHeader collapsed" data-bs-toggle="collapse" data-bs-target="#accordion_LegalNoticeThree" aria-expanded="false" aria-controls="accordion_LegalNoticeThree">Directors List.</a>
                        <div id="accordion_LegalNoticeThree" class="accordion-collapse collapse" data-bs-parent="#accordionLegalNotice">
                            <div class="accordion-body accordionBody">
                                <p>BMW Financial Services (South Africa) (Pty) Ltd. with the following particulars:<br><br>

                                Board of Directors:<br><br>

                                L Y L Ng* (Chairwoman)<br>
                                S F Schuett** (Chief Executive Officer)<br>
                                R G Rooden*** (Chief Financial Officer)<br>
                                C C Pillay<br>
                                T Moodally<br><br>

                                *Chinese<br>
                                **German<br>
                                ***Dutch<br>
                                BMW Financial Services (South Africa) (Pty) Ltd<br>
                                BMW Group Company<br><br>

                                ALPHERA Financial Services is a Division of BMW Financial Services (South Africa) (Pty) Ltd, an Authorised Financial Services Provider (FSP 4623) and Registered Credit Provider (NCRCP2341).</p>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item accordionItem">
                        <a href="javascript:void(0);" class="accordion-header accordionHeader collapsed" data-bs-toggle="collapse" data-bs-target="#accordion_LegalNoticeFour" aria-expanded="false" aria-controls="accordion_LegalNoticeFour">National Credit Act (NCA).</a>
                        <div id="accordion_LegalNoticeFour" class="accordion-collapse collapse" data-bs-parent="#accordionLegalNotice">
                            <div class="accordion-body accordionBody">
                                <p>BMW Financial Services (South Africa) (Pty) Ltd is a Registered Credit Provider (NCRCP2341)</p>


                                    <p>The National Credit Regulator (NCR) handles complaint with regards to NCA compliance.
                                    Their contact details are as follows:
                                </p>
                                <p>
                                    <strong>Tel</strong>: <a href="tel:+27860627627" target="_blank">0860 627 627</a><br>
                                    <strong>Email</strong>: <a href="mailto:complaints@ncr.org.za" target="_blank">complaints&#64;ncr.org.za</a><br>
                                    <strong>Website</strong>: <a href="https://www.ncr.org.za" target="_blank">www.ncr.org.za</a></p>
                                    <div class="col-md-6 col-lg-5 btnWrapper">
                                <a href="./assets/files/Language-Policy.pdf" class="button button-g-blue" target="_blank">Download Language Policy.</a>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div class="accordion-item accordionItem">
                        <a href="javascript:void(0);" class="accordion-header accordionHeader collapsed" data-bs-toggle="collapse" data-bs-target="#accordion_LegalNoticeFive" aria-expanded="false" aria-controls="accordion_LegalNoticeFive">FAIS.</a>
                        <div id="accordion_LegalNoticeFive" class="accordion-collapse collapse" data-bs-parent="#accordionLegalNotice">
                            <div class="accordion-body accordionBody">
                                <p><strong>FAIS Disclosure Notice</strong>.</p>
                                <p>
                                    BMW Financial Services (South Africa) (Pty) Ltd is an Authorised Financial Services Provider, FSP 4623. A copy of our license is available upon request.
                                    <br>
                                    <strong></strong>Address:<br>
                                    BMW Financial Services<br>
                                    1 Bavaria Avenue<br>
                                    Randjespark Ext 17<br>
                                    Midrand <br>
                                    1685 <br>
                                    <strong>Telephone number: </strong>0861 257 437<br>
                                    <strong>Fax Number: </strong>011 541 759<br>
                                    <strong>Registration number: </strong>1960/004670/07<br><br>


                                </p>
                                <p><strong>Complaints Procedure</strong></p>
                                <p>
                                    Please note that in terms of the FAIS Act, all complaints must be addressed to us in writing to <a href="mailto:Complaints@bmwfinance.co.za">{{complaintEmail}}</a>.<br><br>
                                    Should you believe that your complaint has not been resolved satisfactorily by us within six weeks after you have lodged your complaint, you may refer the dispute to the Ombud within six months of the issue remaining unresolved.<br><br>
                                    The details of the Ombud:<br>
                                    <strong>Postal address: </strong>PO Box 74571, Lynnwood Ridge, 0040<br>
                                    <strong>Telephone number: </strong>012 470 9080<br>
                                    <strong>Fax number: </strong>0867 641 422 / 012 348 3447<br>
                                    <strong>Email address: </strong><a href="info@faisombud.co.za">{{faisEmail}}</a><br>
                                    <strong>Website: </strong><a href="www.faisombud.co.za">www.faisombud.co.za</a>
                                </p>

                                <div class="col-md-6 col-lg-5 btnWrapper">
                                    <a href="./assets/files/Alphera-Conflict-of-Interest-Management-Policy.pdf" class="button button-g-blue" target="_blank">FAIS Customer Complaints Resolution Policy.</a>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div class="accordion-item accordionItem">
                        <a href="javascript:void(0);" class="accordion-header accordionHeader collapsed" data-bs-toggle="collapse" data-bs-target="#accordion_LegalNoticeSix" aria-expanded="false" aria-controls="accordion_LegalNoticeSix">
                            Conflict of Interest Policy.
                        </a>
                        <div id="accordion_LegalNoticeSix" class="accordion-collapse collapse" data-bs-parent="#accordionLegalNotice">
                            <div class="accordion-body accordionBody">
                                <p>In compliance with the General Code of Conduct for Authorised Financial Services Providers and Representatives, 
                                    this notice serves to inform you that the BMW Financial Services Conflict of Interest Management Policy may be obtained through contacting <a href="mailto:Compliance-ZA@bmwfinance.co.za" target="_blank">Compliance-ZA&#64;bmwfinance.co.za</a>.</p>
                            </div>
                        </div>
                    </div>

                    
               </div>
            </div>
        </div>
    </section>


</main>